import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import Hero from './components/Hero';
import { theme } from './theme';

function App() {
  return (
    <ChakraProvider theme={theme}>
      <Hero />
    </ChakraProvider>
  );
}

export default App;
